var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:true});exports.default=void 0;

var _react=_interopRequireDefault(require("react"));
var _reactNative=require("react-native");var _this=this,_jsxFileName="/Users/paveljacko/DEV/Code/renative2/packages/renative/src/Icon/index.js";

var fontAwesome=require('react-native-vector-icons/FontAwesome').default;
var feather=require('react-native-vector-icons/Feather').default;
var antDesign=require('react-native-vector-icons/AntDesign').default;
var entypo=require('react-native-vector-icons/Entypo').default;
var evilIcons=require('react-native-vector-icons/EvilIcons').default;
var foundation=require('react-native-vector-icons/Foundation').default;
var ionicons=require('react-native-vector-icons/Ionicons').default;


var materialIcons=require('react-native-vector-icons/MaterialIcons').
default;
var octicons=require('react-native-vector-icons/Octicons').default;
var simpleLineIcons=require('react-native-vector-icons/SimpleLineIcons').
default;
var zocial=require('react-native-vector-icons/Zocial').default;

var IconMap={
fontAwesome:fontAwesome,
feather:feather,
antDesign:antDesign,
entypo:entypo,
evilIcons:evilIcons,
foundation:foundation,
ionicons:ionicons,

materialIcons:materialIcons,
octicons:octicons,
simpleLineIcons:simpleLineIcons,
zocial:zocial};


var IconComponent=function IconComponent(_ref)








{var iconFont=_ref.iconFont,iconName=_ref.iconName,iconColor=_ref.iconColor,onPress=_ref.onPress,style=_ref.style,className=_ref.className,testID=_ref.testID,size=_ref.size;
var IC=IconMap[iconFont];
if(onPress){
return(
_react.default.createElement(_reactNative.TouchableOpacity,{
style:style,
onPress:onPress,
className:className,
testID:testID,__self:_this,__source:{fileName:_jsxFileName,lineNumber:50,columnNumber:13}},

_react.default.createElement(IC,{
style:{color:iconColor},
name:iconName,
size:size||style.width||style.height,__self:_this,__source:{fileName:_jsxFileName,lineNumber:56,columnNumber:17}})));



}
return(
_react.default.createElement(_reactNative.View,{style:style,className:className,testID:testID,__self:_this,__source:{fileName:_jsxFileName,lineNumber:65,columnNumber:9}},
_react.default.createElement(IC,{
style:{color:iconColor},
name:iconName,
size:size||style.width||style.height,__self:_this,__source:{fileName:_jsxFileName,lineNumber:66,columnNumber:13}})));



};var _default=

IconComponent;exports.default=_default;
//# sourceMappingURL=index.js.map